<template>
  <div>
    <div class="page-wrapper" style="font-size: 12px">
      <div class="page-content-wrapper ml-0 px-3 pt-3">
        <h5 class="font-18 bold">
          <a v-if="!type" v-on:click="$router.go(-1)" class="mr-3"
            ><i class="bx bx-arrow-back cursor-pointer"></i
          ></a>
          View Biodata
        </h5>
        <div>
          <div class="tab-content mt-2 form-style" id="memberInfo-tabContent">
            <div
              class="tab-pane fade show active"
              id="BasicInfo"
              role="tabpanel"
              aria-labelledby="BasicInfo-tab">
              <Form ref="saved" @submit="save()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header py-2">
                        <p class="h5 mb-0 bold" style="color: blue">
                          Personal Details
                        </p>
                      </div>
                      <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-md-4" v-if="uuid">
                            <label for="">Reg. No.</label> :
                            <span class="fnt">{{
                              detail.registration_no
                            }}</span>
                          </div>
                          <div class="col-md-3">
                            <label for="">Gender</label
                            ><span class="text-danger">*</span> :
                            <span class="fnt">{{
                              detail.gender == "M" ? "Male" : "Female"
                            }}</span>
                          </div>
                          <div class="col-md-5">
                            <label for="">Marital Status</label
                            ><span class="text-danger">*</span> :
                            <span class="fnt">{{
                              detail.marital_status_id
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Name </label
                            ><span class="text-danger">*</span> :
                            <span class="fnt"
                              >{{ detail.first_name }} {{ detail.middle_name }}
                              {{ detail.last_name }}</span
                            >
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4 mb-2">
                            <div class="form-group">
                              <label>Native Gaon / Area</label>

                              <Field
                                disabled
                                type="text"
                                name="native_place"
                                class="form-control"
                                placeholder="Native Gaon / Area"
                                v-model="detail.native_place_goan" />
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Native Taluka</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="native_place_taluka"
                              v-model="detail.native_place_taluka_id">
                              <option value="" disabled>Select Taluka</option>
                              <option
                                v-for="(data, index) in nativeTalukaList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Native District</label>
                            <span class="text-danger">*</span>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="native_place_district"
                              v-model="detail.native_place_district_id"
                              rules="required: district, true">
                              <option value="" disabled>Select District</option>
                              <option
                                v-for="(data, index) in districtList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="native_place_district"
                              class="text-danger" />
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Date of Birth</label>
                            <Field
                              disabled
                              type="text"
                              name="dob"
                              placeholder="Select date of birth"
                              rules="required:date of birth"
                              v-model="detail.dob"
                              :validateOnInput="true"
                              v-slot="{ field }">
                              <Datepicker
                                autoApply
                                disabled
                                v-model="detail.dob"
                                inputFormat="dd-MM-yyyy"
                                format="dd-MM-yyyy"
                                placeholder="Select date of birth"
                                :maxDate="new Date()"
                                v-bind="field" />
                              <ErrorMessage name="dob" class="text-danger" />
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Height</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="height"
                              v-model="detail.height">
                              <option value="">Select Height</option>
                              <option
                                :value="detail.height"
                                v-if="detail.height">
                                {{ $helperService.getHeight(detail.height) }}
                              </option>
                              <option value="139">
                                {{ $helperService.getHeight(139) }}
                              </option>
                              <option value="142">
                                {{ $helperService.getHeight(142) }}
                              </option>
                              <option value="144">
                                {{ $helperService.getHeight(144) }}
                              </option>
                              <option value="147">
                                {{ $helperService.getHeight(147) }}
                              </option>
                              <option value="149">
                                {{ $helperService.getHeight(149) }}
                              </option>
                              <option value="152">
                                {{ $helperService.getHeight(152) }}
                              </option>
                              <option value="154">
                                {{ $helperService.getHeight(154) }}
                              </option>
                              <option value="157">
                                {{ $helperService.getHeight(157) }}
                              </option>
                              <option value="160">
                                {{ $helperService.getHeight(160) }}
                              </option>
                              <option value="162">
                                {{ $helperService.getHeight(162) }}
                              </option>
                              <option value="165">
                                {{ $helperService.getHeight(165) }}
                              </option>
                              <option value="167">
                                {{ $helperService.getHeight(167) }}
                              </option>
                              <option value="170">
                                {{ $helperService.getHeight(170) }}
                              </option>
                              <option value="172">
                                {{ $helperService.getHeight(172) }}
                              </option>
                              <option value="175">
                                {{ $helperService.getHeight(175) }}
                              </option>
                              <option value="177">
                                {{ $helperService.getHeight(177) }}
                              </option>
                              <option value="180">
                                {{ $helperService.getHeight(180) }}
                              </option>
                              <option value="182">
                                {{ $helperService.getHeight(182) }}
                              </option>
                              <option value="185">
                                {{ $helperService.getHeight(185) }}
                              </option>
                              <option value="187">
                                {{ $helperService.getHeight(187) }}
                              </option>
                              <option value="190">
                                {{ $helperService.getHeight(190) }}
                              </option>
                              <option value="192">
                                {{ $helperService.getHeight(192) }}
                              </option>
                              <option value="195">
                                {{ $helperService.getHeight(195) }}
                              </option>
                              <option value="198">
                                {{ $helperService.getHeight(198) }}
                              </option>
                              <option value="200">
                                {{ $helperService.getHeight(200) }}
                              </option>
                              <option value="203">
                                {{ $helperService.getHeight(203) }}
                              </option>
                              <option value="205">
                                {{ $helperService.getHeight(205) }}
                              </option>
                              <option value="208">
                                {{ $helperService.getHeight(208) }}
                              </option>
                              <option value="210">
                                {{ $helperService.getHeight(210) }}
                              </option>
                              <option value="213">
                                {{ $helperService.getHeight(213) }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Body Structure</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="body_structure"
                              v-model="detail.body_structure_id">
                              <option value="" disabled>
                                Select Body structure
                              </option>
                              <option
                                v-for="(data, index) in bodyStructureList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Blood Group</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="blood_group"
                              v-model="detail.blood_group">
                              <option value="">Select</option>
                              <option value="A +ve">A +ve</option>
                              <option value="A -ve">A -ve</option>
                              <option value="B +ve">B +ve</option>
                              <option value="B -ve">B -ve</option>
                              <option value="O +ve">O +ve</option>
                              <option value="O -ve">O -ve</option>
                              <option value="AB +ve">AB +ve</option>
                              <option value="AB -ve">AB -ve</option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Skin Tone</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="skin_tone"
                              v-model="detail.scan_tone_id">
                              <option value="" disabled>Select Skintone</option>
                              <option
                                v-for="(data, index) in skintoneList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Diet</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="diet"
                              v-model="detail.diet_id">
                              <option value="" disabled>Select Diet</option>
                              <option
                                v-for="(data, index) in dietList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Education/Courses</label>
                            <span class="text-danger">*</span>
                            <Field
                              disabled
                              as="textarea"
                              name="education_courses"
                              placeholder="Education/Courses"
                              v-model="detail.education_courses"
                              rules="required:education courses"
                              :validateOnInput="true"
                              id=""
                              rows="4"
                              class="form-control h-auto"
                              style="height: 100px !important"></Field>
                            <ErrorMessage
                              name="education_courses"
                              class="text-danger" />
                          </div>
                          <div class="col-md-6 mb-2">
                            <div class="col-md-12 mb-2">
                              <label for="">Per.</label>

                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="personality_id"
                                name="personality_id"
                                v-model="detail.personality_id">
                                <option value="" disabled>
                                  Select Personality
                                </option>
                                <option
                                  v-for="(data, index) in personalityList"
                                  :key="index"
                                  :value="data.uuid">
                                  {{ data.name }}
                                </option>
                              </Field>
                            </div>
                            <div class="col-md-12 mb-2">
                              <label for="">Education Group</label>
                              <span class="text-danger">*</span>
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="education_group"
                                v-model="detail.education_group_id"
                                rules="required: eductaion group, true">
                                <option value="" disabled>
                                  Select Education Group
                                </option>
                                <option
                                  v-for="(data, index) in educationGroupList"
                                  :key="index"
                                  :value="data.uuid">
                                  {{ data.name }}
                                </option>
                              </Field>
                              <ErrorMessage
                                name="education_group"
                                class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Occupation Type</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="occupation_type_id"
                              name="occupation_type_id"
                              v-model="detail.occupation_type_id">
                              <option value="" disabled>
                                Select Occupation Type
                              </option>
                              <option
                                v-for="(data, index) in occupationTypeList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Occupation Detail</label>
                            <Field
                              disabled
                              type="text"
                              name="occupation_details"
                              placeholder="Occupation Detail"
                              v-model="detail.occupation_details"
                              class="form-control"></Field>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Ann. Income</label>
                            <span class="text-danger">*</span>
                            <Field
                              disabled
                              type="text"
                              name="annual_income"
                              placeholder="In Lakh"
                              v-model="detail.annual_income"
                              rules="required:annual income"
                              :validateOnInput="true"
                              class="form-control"
                              @keypress="
                                $helperService.allowOnlyNumericValue($event)
                              "></Field>
                            <ErrorMessage
                              name="annual_income"
                              class="text-danger" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Work Location</label>
                            <span class="text-danger">*</span>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              disabled
                              name="working_place_taluka"
                              v-model="detail.working_place_taluka_id"
                              rules="required: work location,true">
                              <option value="" disabled>
                                Select Work Location
                              </option>
                              <option
                                v-for="(data, index) in worklocationList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="working_place_taluka"
                              class="text-danger" />
                          </div>
                          <div class="col mb-2 ps-2">
                            <Field
                              type="text"
                              name="working_place_goan"
                              class="form-control"
                              disabled
                              placeholder="Gaon/Area"
                              v-model="detail.working_place_goan" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Other Information</label>
                            <Field
                              disabled
                              type="text"
                              name="other_info"
                              class="form-control"
                              placeholder="Other Info"
                              v-model="detail.other_info" />
                          </div>
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">Birth Time</label>
                            <Datepicker
                              autoApply
                              disabled
                              placeholder="Select Time"
                              :is-24="false"
                              v-model="detail.birth_time"
                              timePicker />
                          </div>
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">District</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="birth_district"
                              v-model="detail.birth_district_id">
                              <option value="" disabled>Select District</option>
                              <option
                                v-for="(data, index) in districtList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">Mangal</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="is_mangal"
                              v-model="detail.is_mangal">
                              <option value="" disabled>Select Mangal</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                              <option value="SOUMYA">Soumya</option>
                              <option value="NIRDOSH">Nirdosh</option>
                              <option value="NOT_KNOWN">Not Known</option>
                              <option value="NO,">No,</option>
                            </Field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Horoscope Details</label>
                          </div>
                          <div class="col mb-2 pe-2">
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="rashi"
                              v-model="detail.raas_id">
                              <option value="" disabled>Select Rashi</option>
                              <option
                                v-for="(data, index) in rashiList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="nakshtra"
                              v-model="detail.nakshatra_id">
                              <option value="" disabled>Select Nakshtra</option>
                              <option
                                v-for="(data, index) in nakshtraList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="charan"
                              v-model="detail.charan_id">
                              <option value="" disabled>Select Charan</option>
                              <option
                                v-for="(data, index) in charanList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="nadi"
                              v-model="detail.nadi_id">
                              <option value="" disabled>Select Nadi</option>
                              <option
                                v-for="(data, index) in nadiList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="gan"
                              v-model="detail.gan_id">
                              <option value="" disabled>Select Gan</option>
                              <option
                                v-for="(data, index) in ganList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label for="">Devak</label>
                            <div class="com-md-6">
                              <!-- <Field
                                type="text"
                                name="devak"
                                placeholder="Devak"
                                @keypress="$helperService.maxInput($event, 24)"
                                v-model="detail.devak"
                                class="form-control"></Field> -->
                              <!-- <label for="">Devak</label> -->
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="devak"
                                name="devak"
                                v-model="detail.devak">
                                <option value="">Select Devak</option>
                                <option
                                  v-for="(data, index) in devakList"
                                  :key="index"
                                  :value="data.id">
                                  {{ data.name }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Ready to move Abroad?</label>
                            <div class="">
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="ready_to_move_abrod"
                                v-model="detail.ready_to_move_abrod">
                                <option value="" disabled>Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                                <option value="UNDECIDED">Undecided</option>
                                <option value="ALREADY_IN">Already in</option>
                              </Field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2 bg-light border-top">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Expectations
                        </p>
                      </div>
                      <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-md-6">
                            <label for="">Marital Status</label>
                            <div>
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="marrital_status"
                                v-model="detail.expectation.marital_status"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="marriedStatusList"
                                placeholder="Marital Status"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Same Devak</label>
                            <div class="">
                              <Field
                                as="select"
                                class="form-control"
                                id="same_devak"
                                name="same_devak"
                                disabled
                                v-model="detail.expectation.same_devak">
                                <option value="">Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <label for="">Occupation</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="occupation_type"
                                v-model="detail.expectation.occupation_type"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="occupationTypeList"
                                placeholder="Occupation"
                                object="true" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <label for="">Body Structure</label>
                            <Multiselect
                              disabled
                              mode="tags"
                              :searchable="true"
                              name="body_structure"
                              v-model="detail.expectation.body_structure"
                              trackBy="name"
                              label="name"
                              valueProp="uuid"
                              :options="bodyStructureList"
                              placeholder="Body Structure"
                              object="true" />
                          </div>
                          <div class="col-md-6">
                            <label for="">Birth Year</label>
                            <div class="d-flex align-items-center">
                              <Datepicker
                                autoApply
                                disabled
                                placeholder="Select Year"
                                v-model="detail.expectation.birth_year_from"
                                :minDate="detail.expectation.birth_year_from"
                                yearPicker />
                              <label class="mb-0 mx-1">To</label>
                              <Datepicker
                                autoApply
                                disabled
                                placeholder="Select Year"
                                v-model="detail.expectation.birth_year_to"
                                :maxDate="new Date()"
                                yearPicker />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Height</label>
                            <div class="d-flex align-items-center">
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="height_from"
                                v-model="detail.expectation.height_from">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                              <label class="mb-0 mx-1">To</label>
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="height_to"
                                v-model="detail.expectation.height_to">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label for="">Diet</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="diet"
                                v-model="detail.expectation.diet"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="dietList"
                                placeholder="Diet"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Patrika Match</label>
                            <div class="">
                              <Field
                                disabled
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="patrika_match"
                                v-model="detail.expectation.patrika_match">
                                <option value="" disabled>
                                  Select Patrika Match
                                </option>
                                <option value="ALL">Flexible</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-12 mb-2">
                            <label for="">Education Group</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="expectation_education_group"
                                v-model="detail.expectation.education_group"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="educationGroupList"
                                placeholder="Education Group"
                                object="true" />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <label for="">Move to Abroad</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="move_to_abroad"
                                v-model="detail.expectation.move_to_abroad"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="moveToAbroadList"
                                placeholder="Move to Abroad"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Mangal</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="Mangal"
                                v-model="detail.expectation.mangal"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="mangalList"
                                placeholder="Mangal" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Work Location</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="working_city"
                                v-model="detail.expectation.working_city"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="worklocationList"
                                placeholder="Select Work Location"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Native District</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="native_district"
                                v-model="detail.expectation.native_district"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="districtList"
                                placeholder="Select Native District"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Native Taluka</label>
                            <Multiselect
                              disabled
                              style="
                                font-size: 14px;
                                color: #000;
                                font-weight: 500;
                              "
                              mode="tags"
                              :searchable="true"
                              name="native_taluka"
                              v-model="detail.expectation.native_taluka"
                              trackBy="name"
                              label="name"
                              valueProp="uuid"
                              :options="nativeTalukaList"
                              placeholder="Select Native Taluka"
                              object="true" />
                          </div>
                          <!-- <div class="col-md-6 mb-2">
                            <label for="">Family Residence</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="nativeTalukaList"
                                v-model="detail.expectation.family_residence"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="nativeTalukaList"
                                placeholder="Select Taluka"
                                object="true" />
                            </div>
                          </div> -->
                          <div class="col-md-6 mb-2">
                            <label for="">Per.</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="personality"
                                v-model="detail.expectation.personality"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="personalityList"
                                placeholder="Per."
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Relations</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="relation"
                                :groupSelect="true"
                                v-model="detail.expectation.relation"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="relationList"
                                placeholder="Relations"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Eco. Status</label>
                            <div class="">
                              <Multiselect
                                disabled
                                mode="tags"
                                :searchable="true"
                                name="echo_status"
                                v-model="detail.expectation.echo_status"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="echoStatusList"
                                placeholder="Eco. Status"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-12 mb-2">
                            <label for="">Expectations</label>
                            <Field
                              disabled
                              as="textarea"
                              name="occupation_other_expectations"
                              placeholder="Expectations"
                              v-model="
                                detail.expectation.occupation_other_expectations
                              "
                              id=""
                              rows="2"
                              class="form-control h-auto"
                              style="height: 50px !important"></Field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header py-2">
                        <p class="h5 mb-0 bold" style="color: blue">
                          Profile Images
                        </p>
                      </div>

                      <div class="row px-4">
                        <div
                          class="col-lg-4"
                          v-for="(data, index) in detail.user_images"
                          :key="index">
                          <div class="mt-4" v-if="index < 2">
                            <ProductImagePicker
                              :disabled="true"
                              @add-image="addImage($event)"
                              :src="data.image"
                              :modelValue="data.image"
                              :ref="'productImagePicker_' + index" />
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2">
                        <p class="h5 mb-0 bold" style="color: blue">
                          Family Details
                        </p>
                      </div>

                      <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <label for="">Contact Full Name</label>

                                <Field
                                  disabled
                                  type="text"
                                  name="contact_full_name"
                                  placeholder="Contact Full Name"
                                  v-model="
                                    detail.family_details.contact_full_name
                                  "
                                  id=""
                                  rows="4"
                                  class="form-control h-auto"></Field>
                              </div>
                              <div class="col-md-4">
                                <label for="">Address</label>

                                <Field
                                  disabled
                                  type="text"
                                  name="address"
                                  placeholder="Address"
                                  v-model="detail.family_details.address"
                                  class="form-control h-auto"></Field>
                              </div>
                              <div class="col-md-4">
                                <label for="">Area/Gaon</label>

                                <Field
                                  disabled
                                  type="text"
                                  name="Area/Gaon"
                                  placeholder="Area/Gaon"
                                  v-model="detail.family_details.goan"
                                  id=""
                                  rows="4"
                                  class="form-control h-auto"></Field>
                              </div>
                              <div class="col-md-4">
                                <label for="">Taluka</label>
                                <div class="">
                                  <Field
                                    disabled
                                    as="select"
                                    class="form-control"
                                    id="inputRole"
                                    name="taluka"
                                    v-model="detail.family_details.taluka_id"
                                    rules="required:taluka">
                                    <option value="" disabled>
                                      Select Taluka
                                    </option>
                                    <option
                                      v-for="(data, index) in nativeTalukaList"
                                      :key="index"
                                      :value="data.uuid">
                                      {{ data.name }}
                                    </option>
                                  </Field>
                                  <ErrorMessage
                                    name="taluka"
                                    class="text-danger" />
                                </div>
                              </div>
                              <div class="col-md-4">
                                <label for="">District</label>
                                <Field
                                  disabled
                                  as="select"
                                  class="form-control"
                                  id="inputRole"
                                  name="district"
                                  v-model="detail.family_details.district_id">
                                  <option value="" disabled>
                                    Select District
                                  </option>
                                  <option
                                    v-for="(data, index) in districtList"
                                    :key="index"
                                    :value="data.uuid">
                                    {{ data.name }}
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="district"
                                  class="text-danger" />
                              </div>
                              <div class="col-md-4">
                                <label for="">State</label>
                                <Field
                                  disabled
                                  as="select"
                                  class="form-control"
                                  id="inputRole"
                                  name="state"
                                  v-model="detail.family_details.state_id">
                                  <option value="" disabled>
                                    Select State
                                  </option>
                                  <option
                                    v-for="(data, index) in stateList"
                                    :key="index"
                                    :value="data.uuid">
                                    {{ data.name }}
                                  </option>
                                </Field>
                              </div>
                              <div class="col-6">
                                <label for="">Phone by Priority</label>

                                <div
                                  class="d-flex mb-2"
                                  v-for="(data, index) in detail.family_details
                                    .familty_phone_numbers"
                                  :key="index">
                                  <Field
                                    disabled
                                    as="select"
                                    class="form-control mr-2"
                                    :id="'inputRole_' + index"
                                    :name="'type_' + index"
                                    v-model="data.type">
                                    <option value="" disabled>Select</option>
                                    <option value="FATHER">Father</option>
                                    <option value="MOTHER">Mother</option>
                                    <option value="CANDIDATE">Candidate</option>
                                    <option value="BROTHER">Brother</option>
                                    <option value="SISTER">Sister</option>
                                    <option value="KAKA">Kaka</option>
                                    <option value="KAKI">Kaki</option>
                                    <option value="MAMA">Mama</option>
                                    <option value="MAMI">Mami</option>
                                    <option value="MAVSHI">Mavshi</option>
                                    <option value="AATTYA">Aattya</option>
                                    <option value="COUSIN_BROTHER">
                                      Cousin Brother
                                    </option>
                                    <option value="COUSINE_SISTER">
                                      Cousin Sister
                                    </option>
                                    <option value="FRIEND">Friend</option>
                                    <option value="OTHER">Other</option>
                                  </Field>
                                  <div class="col-6">
                                    <Field
                                      disabled
                                      type="text"
                                      class="form-control mr-2"
                                      id="inputRole"
                                      :name="
                                        'family_phone_numbers_phone_' + index
                                      "
                                      v-model="data.phone"
                                      v-on:keypress="
                                        $helperService.allowOnlyNumericValue(
                                          $event
                                        )
                                      " />
                                  </div>
                                  <span
                                    :name="'whatsapp_' + index"
                                    v-on:click="updateWhatsappFlag(data)"
                                    :style="
                                      data.is_whatsapp == 'Y'
                                        ? 'opacity: 1'
                                        : 'opacity: 0.5'
                                    "
                                    class="h5 text-success mr-2 cursor-pointer"
                                    ><i class="bx bxl-whatsapp"></i
                                  ></span>
                                  <span
                                    :name="'phone_' + index"
                                    v-on:click="updateCallFlag(data)"
                                    :style="
                                      data.is_phone == 'Y'
                                        ? 'opacity: 1'
                                        : 'opacity: 0.5'
                                    "
                                    class="h5 cursor-pointer"
                                    ><i class="bx bxs-phone"></i
                                  ></span>
                                </div>
                              </div>

                              <div class="col-md-6">
                                <div class="form-group mt-3">
                                  <label for="">Mobile Number</label>
                                  <span class="text-danger">*</span>
                                  <Field
                                    type="text"
                                    disabled
                                    name="phone"
                                    placeholder="Phone Number"
                                    v-slot="{ field }"
                                    v-model="detail.mobile"
                                    class="form-control mobile_no"
                                    rules="required:Mobile Number"
                                    :validateOnInput="true">
                                    <PhoneCode
                                      id="mobile"
                                      placeholder="Mobile Number"
                                      v-model:countryCode="detail.country_code"
                                      v-model="detail.mobile"
                                      disabled="true"
                                      v-model:dialCode="
                                        detail.mobile_country_code
                                      "
                                      v-bind="field" />
                                  </Field>
                                  <ErrorMessage
                                    name="phone"
                                    class="text-danger" />
                                </div>
                                <div class="form-group">
                                  <label for="">Email</label>

                                  <Field
                                    disabled
                                    type="text"
                                    name="email"
                                    placeholder="Email"
                                    v-model="detail.email"
                                    class="form-control h-auto"></Field>
                                </div>
                              </div>
                              <div class="col-12 form-group">
                                <label for="">Email Id</label>

                                <Field
                                  type="text"
                                  name="family_detailsemail"
                                  placeholder="Email id"
                                  v-model="detail.family_details.email"
                                  class="form-control h-auto gery-light"></Field>
                              </div>
                              <div class="col-6 mb-3">
                                <label for="">Father Occupation</label>

                                <div class="d-flex col-12">
                                  <div class="col-6 mr-2" style="padding: 0">
                                    <Field
                                      disabled
                                      type="text"
                                      name="father_occupation"
                                      placeholder="Father Occupation"
                                      v-model="
                                        detail.family_details.father_occuption
                                      "
                                      class="form-control"></Field>
                                  </div>
                                  <div class="col-6 mr-2" style="padding: 0">
                                    <Field
                                      disabled
                                      type="text"
                                      name="occupation_place"
                                      placeholder="Occupation place"
                                      v-model="
                                        detail.family_details
                                          .father_occuption_place
                                      "
                                      class="form-control h-auto"></Field>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 mb-3">
                                <label for="">Mother Occupation</label>

                                <div class="d-flex col-12">
                                  <div class="col-6 mr-2" style="padding: 0">
                                    <Field
                                      disabled
                                      type="text"
                                      name="mother_occupation"
                                      placeholder="Mother Occupation"
                                      v-model="
                                        detail.family_details.mother_occuption
                                      "
                                      class="form-control"></Field>
                                  </div>
                                  <div class="col-6 mr-2" style="padding: 0">
                                    <Field
                                      disabled
                                      type="text"
                                      name="mother_occupation_place"
                                      placeholder="Occupation place"
                                      v-model="
                                        detail.family_details
                                          .mother_occuption_place
                                      "
                                      class="form-control h-auto"></Field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <div class="row mb-2">
                              <div
                                class="col-md-9"
                                v-if="
                                  detail.family_details.family_members != null
                                ">
                                <label for="">Brother/Sister Details </label>
                              </div>
                              <div class="col-md-3 text-right"></div>
                            </div>

                            <div
                              class="table-responsive"
                              v-if="
                                detail.family_details.family_members != null
                              ">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th style="color: #db1c9c">Name</th>
                                    <th style="color: #db1c9c">Married?</th>
                                    <th style="color: #db1c9c">Education</th>
                                    <th style="color: #db1c9c">Occupation</th>
                                    <th style="color: #db1c9c">Place</th>
                                    <th style="color: #db1c9c">Birth Year</th>
                                    <th style="color: #db1c9c">Height</th>
                                    <th style="color: #db1c9c">Rel</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(data, index) in detail
                                      .family_details.family_members"
                                    :key="index">
                                    <td>{{ data.name ? data.name : "-" }}</td>
                                    <td>
                                      {{
                                        data.is_married
                                          ? data.is_married == "Y"
                                            ? "Yes"
                                            : "No"
                                          : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.education ? data.education : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.occupation ? data.occupation : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.working_place
                                          ? data.working_place
                                          : "-"
                                      }}
                                    </td>

                                    <td>
                                      {{
                                        data.birth_year ? data.birth_year : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.height
                                          ? $helperService.getHeight(
                                              data.height
                                            )
                                          : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.gender
                                          ? data.gender == "M"
                                            ? "Bro"
                                            : "Sis"
                                          : "-"
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Mama Surname</label>
                            <Field
                              disabled
                              type="text"
                              name="mama_surname"
                              placeholder="Mama Surname"
                              v-model="detail.family_details.mama_surname"
                              class="form-control mr-2"></Field>
                          </div>

                          <div class="col-md-4 mb-2">
                            <label for="">Mama Native Taluka</label>
                            <Field
                              disabled
                              type="text"
                              name="mama_taluka_place"
                              placeholder="Mama Native Taluka"
                              v-model="detail.family_details.mama_taluka_place"
                              class="form-control mr-2"></Field>
                          </div>

                          <div class="col-md-4 mb-2">
                            <label for="">Mama Native Gaon</label>
                            <Field
                              disabled
                              type="text"
                              name="mama_native_gaon"
                              placeholder="Mama Native Gaon"
                              v-model="detail.family_details.mama_native_place"
                              class="form-control mr-2"></Field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Relatives</label>
                          </div>
                          <div
                            class="col-md-6 d-flex mb-2"
                            v-for="(data, index) in detail.family_details
                              .relatives"
                            :key="index">
                            <Field
                              disabled
                              type="text"
                              class="form-control mr-2"
                              :id="'surname_' + index"
                              placeholder="Surname"
                              :name="'surname_' + index"
                              v-model="data.surname" />
                            <Field
                              disabled
                              type="text"
                              class="form-control mr-2"
                              :id="'goan_' + index"
                              placeholder="Gaon"
                              :name="'gaon_' + index"
                              v-model="data.goan" />
                          </div>
                          <div class="col-md-3 ml-2"></div>
                          <div class="col-md-3 ml-2">
                            <label for="">R</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="relationship"
                              v-model="detail.family_details.relationship_id">
                              <option value="" disabled>Select relation</option>
                              <option
                                v-for="(data, index) in relationList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>

                          <div class="col-md-4 ml-2">
                            <label for="">ES</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="echo_status"
                              v-model="detail.family_details.echo_status">
                              <option value="" disabled>
                                Select eco status
                              </option>
                              <option
                                v-for="(data, index) in echoStatusList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>

                          <div class="col-md-4 ml-2">
                            <label for="">M.P</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="minus_point1"
                              v-model="detail.family_details.minus_point">
                              <option value="" disabled>
                                Select minus point
                              </option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </Field>
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2 bg-light border-top">
                        <p class="h5 mb-0 bold" style="color: blue">
                          Property Details
                        </p>
                        <div class="text-right"></div>
                      </div>
                      <div class="card-body">
                        <div class="row mb-1">
                          <div
                            class="col-md-10 bg-light py-1"
                            style="color: #db1c9c">
                            Properties, Flat, Land, Business, Vehicle Details
                          </div>
                          <div
                            class="col-md-2 bg-light py-1"
                            style="color: #db1c9c">
                            Property Place
                          </div>
                        </div>
                        <div
                          class="row"
                          v-for="(data, index) in detail.user_properties"
                          :key="index">
                          <div class="col-12 mt-3 row">
                            <div class="col-lg-10 pr-0">
                              <Field
                                disabled
                                type="text"
                                class="form-control mr-2"
                                id="details"
                                placeholder="Property Name"
                                :name="'Name_' + index"
                                v-model="data.details" />
                            </div>
                            <div class="col-lg-2 pr-0">
                              <Field
                                disabled
                                type="text"
                                class="form-control mr-2"
                                id="place"
                                placeholder="Place"
                                :name="'Detail_' + index"
                                v-model="data.place" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-2">
                            <label for="">First Payment Date</label>
                            <Field
                              disabled
                              type="text"
                              name="opening_date"
                              placeholder="Select Date"
                              v-model="detail.opening_date"
                              v-slot="{ field }">
                              <Datepicker
                                autoApply
                                disabled
                                v-model="detail.opening_date"
                                inputFormat="dd-MM-yyyy"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                v-bind="field" />
                            </Field>
                          </div>
                          <div class="col-md-2" v-if="uuid">
                            <label for="">Latest Payment Date</label>

                            <Datepicker
                              autoApply
                              disabled
                              v-model="detail.payment_date"
                              inputFormat="dd-MM-yyyy"
                              format="dd-MM-yyyy"
                              placeholder="Select Date" />
                          </div>
                          <div class="col-md-2" v-if="uuid">
                            <label for=""> Total Amount Paid</label>
                            <Field
                              disabled
                              type="text"
                              name="latest_amount_paid"
                              placeholder="Latest Amount Paid"
                              v-model="detail.latest_amount_paid"
                              class="form-control"></Field>
                          </div>
                          <div class="col-md-2">
                            <label for="">From</label>
                            <Field
                              disabled
                              type="text"
                              name="user_source_from"
                              placeholder="From"
                              v-model="detail.user_source_from"
                              class="form-control mr-2"></Field>
                          </div>
                          <div class="col-md-3">
                            <label for="">Secret</label>
                            <Field
                              disabled
                              type="text"
                              name="secret_text"
                              placeholder="Secret Text"
                              v-model="detail.secret_text"
                              class="form-control mr-2"></Field>
                          </div>
                          <div class="col-md-1 pl-0">
                            <label for="">M.P.</label>
                            <Field
                              disabled
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="minus_point"
                              v-model="detail.minus_point">
                              <option value="" disabled>Select</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </Field>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-md-6">
                            <div class="row mb-3 mt-3">
                              <div class="col-md-6"></div>
                              <div class="col-md-6 py-2">
                                <button
                                  v-if="detail.user_documents"
                                  type="button"
                                  v-on:click="showIdProofPopup()"
                                  class="btn btn-primary"
                                  style="
                                    width: 95px;
                                    font-size: 14px;
                                    height: 30px;
                                    padding: 6px;
                                    left: 0px;
                                  ">
                                  View ID Proof
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 d-flex mt-3">
                            <div class="custom-control custom-switch mr-3">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="admin_dont_share"
                                true-value="Y"
                                false-value="N"
                                disabled
                                v-model="detail.admin_dont_share" />
                              <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="admin_dont_share"
                                >Admin Dont Share</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="verify"
                                true-value="Y"
                                false-value="N"
                                disabled
                                v-model="detail.is_verified_mobile" />
                              <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="verify"
                                >Verify Contact Number</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <ErrorComponent @retry="getDetail()" ref="errorComponent" />
    </div>
    <TextModal ref="textModal">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ detail.uuid ? "View" : "Upload" }} Address & ID Proof
        </h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.textModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="IdForm" @submit="saveIdProof()">
        <div class="modal-body">
          <div class="form-group col-lg-12">
            <label for="inputRole">ID proof</label>
            <span class="text-danger">*</span>
            <Field
              disabled
              as="select"
              class="form-control"
              id="inputRole"
              name="name_country"
              v-model="documentDetail.type"
              rules="required:id proof">
              <option value="" disabled>Select ID proof</option>
              <option value="AADHAR">Aadhar Card</option>
              <option value="LICENCE">Driving License</option>
              <option value="PANCARD">PAN Card</option>
              <option value="PASSPORT">Passport</option>
              <option value="VOTER_ID">Voter ID</option>
            </Field>
            <ErrorMessage name="name_country" class="text-danger" />
          </div>
          <div class="col-lg-12 col-sm-12 mb-3 row">
            <div class="col-md-6 mb-4">
              <DocumentPicker
                isdisabled="true"
                :src="
                  documentDetail.front_image ? documentDetail.front_image : ''
                "
                ref="documentFrontImage" />
            </div>
            <div class="col-md-6 mb-4">
              <DocumentPicker
                isdisabled="true"
                :src="
                  documentDetail.back_image ? documentDetail.back_image : ''
                "
                ref="documentBackImage" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.textModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>
    <TextModal ref="BrotherSisterModal">
      <div class="modal-header">
        <h5 class="modal-title">Add Brother/Sister Details</h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.BrotherSisterModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="BrotherSisterForm" @submit="saveBrotherSister()">
        <div class="modal-body">
          <div class="col-lg-12 col-sm-12 row">
            <div class="col-lg-12">
              <span style="font-size: 12px; font-weight: bold"
                >If sister is married, mention surname only</span
              >
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>First Name</label>
                <Field
                  disabled
                  type="text"
                  class="form-control"
                  name="name"
                  v-model="brotherSisterObj.name"
                  placeholder="First Name" />
              </div>
            </div>

            <div class="form-group col-lg-6">
              <label for="inputRole">Married?</label>
              <Field
                disabled
                as="select"
                class="form-control"
                id="inputRole"
                name="is_married"
                v-model="brotherSisterObj.is_married">
                <option value="" disabled>Select Status</option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </Field>
            </div>
          </div>

          <div class="col-lg-12 col-sm-12 row">
            <div class="form-group col-lg-6">
              <label>Education</label>
              <Field
                disabled
                type="text"
                class="form-control"
                name="education"
                v-model="brotherSisterObj.education"
                placeholder="Education" />
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>Occupation</label>
                <Field
                  disabled
                  type="text"
                  class="form-control"
                  name="occupation"
                  v-model="brotherSisterObj.occupation"
                  placeholder="Occupation" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>Working Place</label>
              <Field
                disabled
                type="text"
                class="form-control"
                name="working_place"
                v-model="brotherSisterObj.working_place"
                placeholder="Working Place" />
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>Birth Year</label>

              <Field
                disabled
                type="text"
                name="birth_year"
                placeholder="Select date of birth"
                v-model="brotherSisterObj.birth_year"
                v-slot="{ field }">
                <Datepicker
                  autoApply
                  disabled
                  v-model="brotherSisterObj.birth_year"
                  inputFormat="dd-MM-yyyy"
                  format="yyyy"
                  placeholder="Select Year"
                  :maxDate="new Date()"
                  v-bind="field"
                  yearPicker />
              </Field>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <label for="">Height</label>
            <Field
              disabled
              as="select"
              class="form-control"
              id="inputRole"
              name="height"
              v-model="brotherSisterObj.height">
              <option value="">Select Height</option>
              <option value="139">
                {{ $helperService.getHeight(139) }}
              </option>
              <option value="142">
                {{ $helperService.getHeight(142) }}
              </option>
              <option value="144">
                {{ $helperService.getHeight(144) }}
              </option>
              <option value="147">
                {{ $helperService.getHeight(147) }}
              </option>
              <option value="149">
                {{ $helperService.getHeight(149) }}
              </option>
              <option value="152">
                {{ $helperService.getHeight(152) }}
              </option>
              <option value="154">
                {{ $helperService.getHeight(154) }}
              </option>
              <option value="157">
                {{ $helperService.getHeight(157) }}
              </option>
              <option value="160">
                {{ $helperService.getHeight(160) }}
              </option>
              <option value="162">
                {{ $helperService.getHeight(162) }}
              </option>
              <option value="165">
                {{ $helperService.getHeight(165) }}
              </option>
              <option value="167">
                {{ $helperService.getHeight(167) }}
              </option>
              <option value="170">
                {{ $helperService.getHeight(170) }}
              </option>
              <option value="172">
                {{ $helperService.getHeight(172) }}
              </option>
              <option value="175">
                {{ $helperService.getHeight(175) }}
              </option>
              <option value="177">
                {{ $helperService.getHeight(177) }}
              </option>
              <option value="180">
                {{ $helperService.getHeight(180) }}
              </option>
              <option value="182">
                {{ $helperService.getHeight(182) }}
              </option>
              <option value="185">
                {{ $helperService.getHeight(185) }}
              </option>
              <option value="187">
                {{ $helperService.getHeight(187) }}
              </option>
              <option value="190">
                {{ $helperService.getHeight(190) }}
              </option>
              <option value="192">
                {{ $helperService.getHeight(192) }}
              </option>
              <option value="195">
                {{ $helperService.getHeight(195) }}
              </option>
              <option value="198">
                {{ $helperService.getHeight(198) }}
              </option>
              <option value="200">
                {{ $helperService.getHeight(200) }}
              </option>
              <option value="203">
                {{ $helperService.getHeight(203) }}
              </option>
              <option value="205">
                {{ $helperService.getHeight(205) }}
              </option>
              <option value="208">
                {{ $helperService.getHeight(208) }}
              </option>
              <option value="210">
                {{ $helperService.getHeight(210) }}
              </option>
              <option value="213">
                {{ $helperService.getHeight(213) }}
              </option>
            </Field>
          </div>
          <div class="col-md-12 mb-2 mt-1">
            <label for="">Gender</label>

            <Field
              disabled
              as="select"
              class="form-control"
              id="inputRole"
              name="genderType"
              v-model="brotherSisterObj.gender">
              <option value="" disabled>Select Gender</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </Field>
          </div>
        </div>
        <div class="modal-footer">
          <button id="Brother_Sister" class="fill-btn">Save</button>
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.BrotherSisterModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import Multiselect from "@vueform/multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import TextModal from "@/components/TextModal";
import "@vuepic/vue-datepicker/dist/main.css";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode.vue";
import ProductImagePicker from "../../components/ProductImagePicker.vue";
import DocumentPicker from "@/components/DocumentPicker.vue";
import moment from "moment";
export default {
  name: "AddUser",
  components: {
    Form,
    Field,
    ErrorMessage,
    DocumentPicker,
    ErrorComponent,
    Multiselect,
    ProductImagePicker,
    TextModal,
    Datepicker,
    PhoneCode,
  },
  data() {
    return {
      image_limit: 5,
      documentDetail: {
        type: "LICENCE",
      },
      myArr: [],
      worklocationList: [],
      currentTab: "",
      uuid: this.$route.params.uuid,
      type: this.$route.params.type,
      user_uuid: this.$route.params.user_uuid,
      brotherSisterObj: {
        name: "",
        is_married: "",
        education: "",
        occupation: "",
        working_place: "",
        birth_year: "",
        height: "",
        gender: "",
      },
      detail: {
        user_properties: [{}],
        brotherSisterObj: {},
        is_mangal: "",
        document_id: "",
        user_images: [{ image_id: 0 }, { image_id: 1 }],
        birth_district_id: "",
        images: [],
        type: "",
        id_number: "",
        blood_group: "",
        dob: "",
        membership_plan_id: "",
        marital_status_id: "",
        native_place_taluka_id: "",
        native_place_district_id: "",
        height: "",
        body_structure_id: "",
        scan_tone_id: "",
        diet_id: "",
        education_group_id: "",
        personality_id: " ",
        occupation_type_id: "",
        working_place_country_id: "",
        working_place_state_id: "",
        working_place_district_id: "",
        working_place_taluka_id: "",
        raas_id: "",
        nakshatra_id: "",
        charan_id: "",
        nadi_id: "",
        gan_id: "",
        ready_to_move_abrod: "",
        is_hidden: "N",
        admin_dont_share: "N",
        block: "N",
        is_verified_mobile: "N",
        family_details: {
          family_members: [],
          familty_phone_numbers: [
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
          ],
          relatives: [
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
          ],
        },
        expectation: {
          move_to_abroad: [],
          birth_year_from: "",
          birth_year_to: "",
          same_devak: "N",
          height_from: "",
          height_to: "",
          expected_educations: "",
          occupation_other_expectations: "",
          marital_status: [],
          occupation_type: [],
          body_structure: [],
          diet: [],
          mangal: [],
          education_group: [],
          working_city: [],
          native_district: [],
          native_taluka: [],
          family_residence: [],
          working_country: [],
          personality: [],
          relation: [],
          echo_status: [],
        },
        user_document: [],
      },
      membershipPlanList: [],
      marriedStatusList: [],
      devakList: [],
      nativeTalukaList: [],
      districtList: [],
      countryList: [],
      bodyStructureList: [],
      skintoneList: [],
      dietList: [],
      educationGroupList: [],
      occupationTypeList: [],
      stateList: [],
      rashiList: [],
      nakshtraList: [],
      charanList: [],
      nadiList: [],
      ganList: [],
      relationList: [],
      personalityList: [],
      echoStatusList: [],
      moveToAbroadList: [
        { name: "All ", value: "ALL" },
        { name: "Yes ", value: "Y" },
        { name: "No ", value: "N" },
        { name: "Undecided ", value: "UNDECIDED" },
        { name: "Already in ", value: "ALREADY_IN" },
      ],
      mangalList: [
        { name: "Yes", uuid: "Y" },
        { name: "No", uuid: "N" },
        { name: "Soumya", uuid: "SOUMYA" },
        { name: "Nirdosh", uuid: "NIRDOSH" },
        { name: "Not Known", uuid: "NOT_KNOWN" },
        { name: "NO,", uuid: "NO," },
      ],
    };
  },
  mounted() {
    this.$helperService.showMenu("false");
    this.getMembershipPlanList();
    this.getStatusList("MARITAL_STATUS");
    this.getStatusList("DEVAK");
    this.getStatusList("BODY_STRUCTURE");
    this.getStatusList("SKIN_TONE");
    this.getStatusList("DIET");
    this.getStatusList("EDUCATION_GROUP");
    this.getStatusList("OCCUPATION_TYPE");
    this.getStatusList("RAAS");
    this.getStatusList("NAKSHTRA");
    this.getStatusList("CHARAN");
    this.getStatusList("NADI");
    this.getStatusList("GAN");
    this.getStatusList("RELATION");
    this.getStatusList("ECO_STATUS");
    this.getStatusList("PERSONALITY");
    this.getStatusList("MOVE_TO_ABROAD");
    this.getTalukaList();
    this.getWorkLocationList();
    this.getDistrictList();
    this.getCountryList();
    this.getStateList();
    if (this.uuid) {
      this.getDetail();
    }
    this.changeTab("BASIC_INFO");
  },
  methods: {
    importFamilyDetail() {
      this.$router.push("/add-user");
      this.uuid = null;
      this.detail.expectation = {};
      this.detail.first_name = "";
      this.detail.middle_name = "";
      this.detail.marital_status_id = "";
      this.detail.registration_no = "";
      this.detail.gender = "";
      this.detail.last_name = "";
      this.detail.middle_name = "";
      this.detail.native_place_goan = "";
      this.detail.native_place_taluka_id = "";
      this.detail.native_place_district_id = "";
      this.detail.dob = "";
      this.detail.height = "";
      this.detail.body_structure_id = "";
      this.detail.blood_group = "";
      this.detail.scan_tone_id = "";
      this.detail.diet_id = "";
      this.detail.education_courses = "";
      this.detail.education_group_id = "";
      this.detail.personality_id = "";
      this.detail.occupation_type_id = "";
      this.detail.occupation_details = "";
      this.detail.annual_income = "";
      this.detail.working_place_country_id = "";
      this.detail.working_place_state_id = "";
      this.detail.working_place_district_id = "";
      this.detail.working_place_taluka_id = "";
      this.detail.working_place_goan = "";
      this.detail.other_info = "";
      this.detail.birth_time = "";
      this.detail.birth_district_id = "";
      this.detail.gun = "";
      this.detail.is_mangal = "";
      this.detail.raas_id = "";
      this.detail.nakshatra_id = "";
      this.detail.charan_id = "";
      this.detail.nadi_id = "";
      this.detail.gan_id = "";
      this.detail.devak = "";
      this.detail.ready_to_move_abrod = "";
      this.detail.user_images = [{ image_id: 0 }, { image_id: 1 }];
      this.user_document = [{}];
    },
    getDoumentDetail() {
      if (this.uuid) {
        this.$api
          .getAPI({
            _action: "/document/detail/" + this.uuid,
          })
          .then((res) => {
            if (res) {
              this.documentDetail = res;
            }
          })
          .catch(() => {});
      }
    },
    removevideoObj(index) {
      this.detail.user_properties.splice(index, 1);
    },
    addVideoObj() {
      this.detail.user_properties.push({});
    },
    getDetail() {
      this.$refs.saved.resetForm();
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/details/user/" + this.uuid,
        })
        .then((res) => {
          if (!res.family_details) {
            res.family_details = {
              family_members: [],
              familty_phone_numbers: [
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
              ],
              relatives: [
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
              ],
            };
          }
          if (res.user_properties && res.user_properties.length == 0) {
            res.user_properties.push({
              details: "",
              place: "",
            });
          }
          if (res.family_details && res.family_details.relatives.length == 0) {
            res.family_details.relatives = [
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
            ];
          }
          if (res.family_details && res.family_details.relatives.length > 0) {
            var length = 5 - res.family_details.relatives.length;
            if (length > 0) {
              for (var i = 0; i < length; i++) {
                res.family_details.relatives.push({
                  surname: "",
                  goan: "",
                });
              }
            }
          }
          if (res.family_details && res.family_details.relatives.length > 5) {
            for (var z in res.family_details.relatives) {
              if (z > 4) {
                res.family_details.relatives.splice(1, z);
              }
            }
          }
          if (res.birth_time) {
            var time = res.birth_time.split(":");
            res.birth_time = {
              hours: time[0],
              minutes: time[1],
              seconds: time[2],
            };
          }
          res.marital_status_id = res.marital_status_text
            ? res.marital_status_text
            : "";
          if (!res.expectation || res.expectation == null) {
            res.expectation = {
              move_to_abroad: [],
              birth_year_from: "",
              birth_year_to: "",
              height_from: "",
              height_to: "",
              expected_educations: "",
              occupation_other_expectations: "",
              marital_status: [],
              mangal: [],
              occupation_type: [],
              body_structure: [],
              diet: [],
              education_group: [],
              working_city: [],
              native_district: [],
              native_taluka: [],
              family_residence: [],
              working_country: [],
              personality: [],
              relation: [],
              echo_status: [],
            };
          }
          this.detail = res;

          if (!this.detail.brotherSisterObj) {
            this.detail.brotherSisterObj = {};
          }
          if (this.detail.expectation == null) {
            this.detail.expectation = {
              marital_status: [],
            };
          }
          if (
            this.detail.family_details &&
            this.detail.family_details.familty_phone_numbers.length == 0
          ) {
            this.detail.family_details.familty_phone_numbers.push(
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              },
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              },
              {
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              }
            );
          }
          this.getStatusList("CHARAN", this.detail.nakshatra_id);
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res);
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    updateWhatsappFlag(data) {
      if (data.is_whatsapp == "N") {
        return (data.is_whatsapp = "Y");
      } else {
        return (data.is_whatsapp = "N");
      }
    },
    updateCallFlag(data) {
      if (data.is_phone == "N") {
        return (data.is_phone = "Y");
      } else {
        return (data.is_phone = "N");
      }
    },
    getWorkLocationList() {
      this.$api
        .getAPI({
          _action: "/work-location/list",
        })
        .then((res) => {
          this.worklocationList = res;
        })
        .catch(() => {});
    },
    getStatusList(type) {
      var obj = {};
      obj.type = type;
      this.$api
        .getAPI({
          _action: "/master-data/list",
          _body: obj,
        })
        .then((res) => {
          if (type == "MARITAL_STATUS") {
            this.marriedStatusList = res.list;
          }
          if (type == "DEVAK") {
            this.devakList = res.list;
          }
          if (type == "BODY_STRUCTURE") {
            this.bodyStructureList = res.list;
          }
          if (type == "SKIN_TONE") {
            this.skintoneList = res.list;
          }
          if (type == "DIET") {
            this.dietList = res.list;
          }
          if (type == "EDUCATION_GROUP") {
            this.educationGroupList = res.list;
          }
          if (type == "PERSONALITY") {
            this.personalityList = res.list;
          }
          if (type == "OCCUPATION_TYPE") {
            this.occupationTypeList = res.list;
          }
          if (type == "RAAS") {
            this.rashiList = res.list;
          }
          if (type == "NAKSHTRA") {
            this.nakshtraList = res.list;
          }
          if (type == "CHARAN") {
            this.charanList = res.list;
          }
          if (type == "NADI") {
            this.nadiList = res.list;
          }
          if (type == "GAN") {
            this.ganList = res.list;
          }
          if (type == "RELATION") {
            this.relationList = res.list;
          }
          if (type == "ECO_STATUS") {
            this.echoStatusList = res.list;
          }
          if (type == "MOVE_TO_ABROAD") {
            this.moveToAbroadList = res.list;
          }
        })
        .catch(() => {});
    },
    getMembershipPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.membershipPlanList = res.list;
        })
        .catch(() => {});
    },

    getTalukaList() {
      this.$api
        .getAPI({
          _action: "/taluka/list",
        })
        .then((res) => {
          this.nativeTalukaList = res;
        })
        .catch(() => {});
    },
    getDistrictList() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.districtList = res;
        })
        .catch(() => {});
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
        })
        .catch(() => {});
    },
    getStateList() {
      this.$api
        .getAPI({
          _action: "/state/list",
        })
        .then((res) => {
          this.stateList = res;
        })
        .catch(() => {});
    },
    addImage(e) {
      var add_new_block = new Proxy(e, {}).add_new_block;
      if (this.detail.user_images.length < 5 && add_new_block) {
        this.detail.user_images.push({});
      }
    },
    save() {
      if (this.detail.birth_time) {
        this.detail.birth_time = moment(this.detail.birth_time).format(
          "HH:MM:SS"
        );
      }
      if (this.uuid) {
        this.detail.uuid = this.uuid;
        this.$api
          .putAPI({
            _action: "/update/user",
            _body: this.detail,
            _buttonId: "save-button111",
          })
          .then((res) => {
            for (var j in this.detail.user_images) {
              var obsStep = "productImagePicker_" + j;
              this.uploadUserImage(
                res.uuid,
                this.$refs[obsStep][0].file,
                this.detail.user_images[j].uuid
              );
            }
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/add/user",
            _body: this.detail,
            _buttonId: "save-button111",
          })
          .then((res) => {
            for (var j in this.detail.user_images) {
              var obsStep = "productImagePicker_" + j;
              this.uploadUserImage(
                res.uuid,
                this.$refs[obsStep][0].file,
                this.detail.user_images[j].uuid
              );
            }
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    uploadUserImage(uuid, imageFile, image_id) {
      if (imageFile) {
        this.$api
          .uploadImageAPI({
            _action: "/add/photo",
            _key: "image",
            _file: imageFile,
            _body: {
              uuid: uuid,
              image_id: image_id,
            },
          })
          .then(() => {});
      } else {
        this.$router.push("/member-list");
      }
    },
    showIdProofPopup() {
      this.$refs.IdForm.resetForm();
      if (this.uuid) {
        this.getDoumentDetail();
      }
      this.$refs.textModal.increaseModelWidth();
      this.$refs.textModal.showModal();
    },
    saveIdProof() {
      if (
        !this.$refs.documentFrontImage.file &&
        !this.documentDetail.front_image
      ) {
        this.$notify({
          type: "error",
          text: "Please upload front image.",
        });
        return;
      }
      if (
        !this.$refs.documentBackImage.file &&
        !this.documentDetail.back_image
      ) {
        this.$notify({
          type: "error",
          text: "Please upload back image.",
        });
        return;
      }

      this.$api
        .postAPI({
          _action: "/add/document",
          _body: this.documentDetail,
          _buttonId: "save-document",
        })
        .then((res) => {
          this.detail.document_id = res.uuid;
          if (this.$refs.documentFrontImage.file) {
            this.uploadImage(
              res.uuid,
              "FRONT",
              this.$refs.documentFrontImage.file
            );
          } else if (this.$refs.documentBackImage.file) {
            this.uploadImage(
              res.uuid,
              "BACK",
              this.$refs.documentBackImage.file
            );
          } else {
            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
            this.$refs.textModal.closeModal();
          }
        })
        .catch(() => {});
    },
    uploadImage(uuid, image_type, file, type) {
      this.$api
        .uploadImageAPI({
          _action: "/add/document/photo",
          _key: "image",
          _file: file,
          _body: {
            uuid: uuid,
            image_type: image_type,
          },
        })
        .then(() => {
          if (this.$refs.documentBackImage.file && !type) {
            this.uploadImage(
              uuid,
              "BACK",
              this.$refs.documentBackImage.file,
              true
            );
          } else {
            this.getDoumentDetail();
            this.$refs.textModal.closeModal();
            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
          }
        });
    },
    showBrotherSisterPopup() {
      this.detail.uuid = "";
      this.$refs.BrotherSisterForm.resetForm();
      this.$refs.BrotherSisterModal.showModal();
    },
    saveBrotherSister() {
      var obj = {
        name: this.brotherSisterObj.name,
        is_married: this.brotherSisterObj.is_married,
        education: this.brotherSisterObj.education,
        occupation: this.brotherSisterObj.occupation,
        working_place: this.brotherSisterObj.working_place,
        birth_year: this.brotherSisterObj.birth_year,
        height: this.brotherSisterObj.height,
        gender: this.brotherSisterObj.gender,
        indx: null,
      };
      if (this.brotherSisterObj.indx != null) {
        for (var i in this.detail.family_details.family_members) {
          if (i == this.brotherSisterObj.indx) {
            this.detail.family_details.family_members[i] =
              this.brotherSisterObj;
          }
        }
      } else {
        this.detail.family_details.family_members.push(obj);
      }

      this.$refs.BrotherSisterModal.closeModal();
    },
    removeBrotherSister(index) {
      this.detail.family_details.family_members.splice(index, 1);
    },
    editBrotherSister(index) {
      this.brotherSisterObj = this.detail.family_details.family_members[index];
      this.brotherSisterObj.indx = index;
      this.$refs.BrotherSisterModal.showModal();
    },
    onChange(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png" &&
        files[0].type.toLowerCase() != "image/svg+xml"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.detail.images.push({
        image: files[0],
        image_type: "FRONT",
      });
      document.getElementById("preview").src = tmppath;
    },
    selectedFile(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png" &&
        files[0].type.toLowerCase() != "image/svg+xml"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.back_image = files[0];
      this.detail.images.push({
        image: files[0],
        image_type: "BACK",
      });
      document.getElementById("back_image").src = tmppath;
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css">
/* .sidebar-wrapper {
  width: 0;
} */
.form-style .form-check-input {
  display: none;
}
.form-style label {
  font-size: 14px;
  margin-bottom: 3px;
  line-height: 16px;
}
.form-style .form-control {
  font-size: 14px;
  height: 30px;
  padding: 3px 6px;
}
.form-style .table tr td {
  padding: 3px 5px;
  font-size: 14px;
  line-height: 19px;
}
.form-style .table tr th {
  padding: 5px 5px;
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
}
</style>
<style scoped>
.multiselect {
  /* background: white !important; */
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #d35bc1 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}

.photo-slider .carousel-item img {
  height: 350px;
}
.photo-slider .carousel-indicators {
  position: initial;
  margin-bottom: 0;
  overflow-x: hidden;
  width: 482px;
  margin: 0 auto;
  justify-content: start;
}
.photo-slider .carousel-indicators li {
  background-color: #bd1c9c;
  text-indent: 0;
  border: 1px solid #c6c6c6;
  width: auto !important;
  height: auto;
  cursor: pointer;
}
.photo-slider .carousel-indicators li.active {
  border-color: #bd1c9c;
  box-shadow: 1px 1px 6px #4242427a;
}
.photo-slider .carousel-indicators .slider-thumb-img {
  width: 55px;
  height: 70px;
  object-fit: cover;
}
.carousel-indicators li:before,
.carousel-indicators li:after {
  content: unset;
}
.photo-slider .carousel-inner {
  padding-bottom: 15px;
}
.photo-slider .crop-thumbnail {
  position: absolute;
  top: 0;
  z-index: 999999;
  margin: 0 5px;
  background: #ffffffbf;
  padding: 3px 4px;
  line-height: 16px;
}
.photo-slider .horizon-prev {
  position: absolute;
  bottom: 32px;
}
.photo-slider .horizon-next {
  position: absolute;
  bottom: 32px;
  right: 0;
}
label {
  font-size: 13px;
}
.mb-2,
.my-2 {
  margin-bottom: 0.1rem !important;
}
</style>
